import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import NearbyFastSlider from "@/components/site/NearbyFastSlider";
import BookingForm from "@/components/site/BookingForm";
import BookingCTA from "@/components/home/BookingCTA";
import LazyImage from "@/components/site/LazyImage";
import { Reveal } from "@/components/site/Reveal";
import { NEARBY } from "@/data/content";

export default function Nearby() {
  return (
    <PageShell testId="nearby-page">
      <PageHero
        overline="Around The Valley"
        title={["Nearby", "Attractions"]}
        subtitle="Waterfalls, misty peaks, ancient temples and hanging bridges — all a short drive from your cottage."
        image={NEARBY[0].image}
      />

      {/* Fast live slider */}
      <NearbyFastSlider heading={false} />

      <section className="bg-ivory py-16 md:py-24">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal><p className="mb-10 text-xs uppercase tracking-widest-2 text-brown md:text-sm">Places To Explore</p></Reveal>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-5">
            {NEARBY.map((p, i) => (
              <Reveal key={p.name} delay={(i % 5) * 0.05}>
                <div className="group overflow-hidden rounded-2xl">
                  <div className="relative">
                    <LazyImage src={p.image} alt={p.name} fit="contain" className="aspect-[3/4]" />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-forest/85 to-transparent" />
                    <div className="absolute inset-x-0 bottom-0 p-3">
                      {p.distance && <p className="text-xs text-champagne">{p.distance} away</p>}
                      <p className="font-display text-lg font-bold leading-tight text-ivory">{p.name}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <BookingForm />
      <BookingCTA />
    </PageShell>
  );
}
